/**
 * @description 省市区(多级选中)
 * @deprecated 2019年9月9日
 * @create by 吕俊
 */
<template>
  <div class="custom-province" v-clickout="hideModal" @click.stop>
    <div class="cp-input" @click="focus">
      <el-input class="el-select el-select--small" :placeholder="placeholder" :value="valueInput" :name="name" readonly clearable>
        <i slot="suffix" v-if="!clearable" class="el-input__icon el-icon-arrow-down" :class="isShow ? 'el-select__caret' : ''"></i>
        <i v-else slot="suffix" @click="clearInput" class="el-icon-circle-close"></i>
      </el-input>
    </div>
    <div class="cp-modal" v-show="isShow">
      <div class="cpm-ul">
        <template v-for="(item, index) in initData">
          <div
            ref="pList"
            :key="item.id"
            v-if="index < showLevel"
            @click="clickTab(index)"
            class="cpml-li"
            :class="[item.isActive ? 'isActive' : '', item.disable ? 'disable' : '']"
          >
            {{ item.name }}
          </div>
        </template>
        <div class="cpml-line" :style="'width:' + lineWidth + 'px;' + 'transform:translateX(' + lineLeftW + 'px)'"></div>
      </div>
      <div class="cpm-content">
        <el-scrollbar>
          <template v-if="typeClass === 0">
            <div class="cpmc-li" ref="cmpcli" v-for="item in provinceList" @click="selectListClick(item.id)" :class="item.isSelectActive ? 'isSelectActive' : ''" :key="item.id">
              {{ item.nativeName }}
            </div>
          </template>
          <template v-if="typeClass === 1">
            <div class="cpmc-li" ref="cmpcli" v-for="item in cityList" @click="selectListClick(item.id)" :class="item.isSelectActive ? 'isSelectActive' : ''" :key="item.id">
              {{ item.nativeName }}
            </div>
          </template>
          <template v-if="typeClass === 2">
            <div class="cpmc-li" ref="cmpcli" v-for="item in areaList" @click="selectListClick(item.id)" :class="item.isSelectActive ? 'isSelectActive' : ''" :key="item.id">
              {{ item.nativeName }}
            </div>
          </template>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import { RESPONSE_SUCCESS } from '@constants'
// import fetch from '../../http/request'

// const reqSysArea = (params = {}) => {
//   params.size = params.size || 5000
//   return fetch.get('/lmdm/sysArea/select', { params })
// }
export default {
  name: 'BaseSelectMore',
  props: {
    /* eslint-disable */
    type: 'search',
    /* eslint-disable */
    value: '',
    showLevel: {
      default: 3
    }
  },
  data() {
    return {
      isShow: false,
      placeholder: this.$lang('请选择省市区'),
      activeName: 'first',
      lineWidth: 0,
      lineLeftW: 10,
      initData: [
        {
          name: this.$lang('省份'),
          isActive: true,
          disable: false
        },
        {
          name: this.$lang('城市'),
          isActive: false,
          disable: true
        },
        {
          name: this.$lang('区县'),
          isActive: false,
          disable: true
        }
      ],
      provinceList: [],
      cityList: [],
      areaList: [],
      typeClass: 0,
      addressInfo: {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: ''
      },
      name: '',
      valueInput: '',
      clearable: false,
      suffixIcon: 'el-icon-arrow-down'
    }
  },
  created() {
    this.getProList()
    this.initParams()
  },
  methods: {
    initParams() {
      const isArray = Array.isArray(this.value)
      this.FormValue = isArray ? this.value : []
      // console.log('aa', this.FormValue)
    },
    hideModal() {
      this.isShow = false
    },
    focus() {
      this.isShow = !this.isShow
      // console.log('this.FormValue.length', this.FormValue.length)
      if (this.FormValue.length > 0) {
        this.initData.map(item => (item.disable = true))
        this.initData[0].disable = false
      } else {
        setTimeout(() => {
          const { clientWidth } = this.$refs.pList[0]
          this.lineWidth = clientWidth
        }, 10)
      }
    },
    // 点击tab
    clickTab(index) {
      if (index === 0) {
        if (this.initData[0].disable) return
        // 省
        const { clientWidth } = this.$refs.pList[0]
        this.lineLeftW = 10
        setTimeout(() => {
          this.lineWidth = clientWidth
        }, 200)
        this.selectList = this.provinceList
        this.typeClass = index
        this.initData.map(item => (item.isActive = false))
        this.initData[index].isActive = true
      } else if (index === 1) {
        if (this.initData[1].disable) return
        // 市
        const { clientWidth } = this.$refs.pList[1]
        this.lineLeftW = this.$refs.pList[1].getBoundingClientRect().x - this.$refs.pList[0].getBoundingClientRect().x + 10
        this.lineWidth = clientWidth
        this.selectList = this.cityList
        this.typeClass = index
        this.initData.map(item => (item.isActive = false))
        this.initData[index].isActive = true
      } else {
        if (this.initData[2].disable) return
        // 区
        const { clientWidth } = this.$refs.pList[2]
        this.lineLeftW = this.$refs.pList[2].getBoundingClientRect().x - this.$refs.pList[0].getBoundingClientRect().x + 10
        this.lineWidth = clientWidth
        this.selectList = this.areaList
        this.typeClass = index
        this.initData.map(item => (item.isActive = false))
        this.initData[index].isActive = true
      }
    },
    // async reqSysArea(params = {}) {
    //   params.size = params.size || 5000
    //   return fetch.get('/lmdm/sysArea/select', { params })
    // },
    // 获取省数据
    async getProList() {
      // const { data, code, msg } = await reqSysArea({ type: 2 })
      const { data, code, msg } = {
        code: 1,
        msg: '请求成功',
        data: {
          records: [
            { id: 2, name: null, enName: '', cnName: '', code: '2', nativeName: '北京市' },
            { id: 3, name: null, enName: '', cnName: '', code: '3', nativeName: '安徽省' },
            { id: 4, name: null, enName: '', cnName: '', code: '4', nativeName: '福建省' },
            { id: 5, name: null, enName: '', cnName: '', code: '5', nativeName: '甘肃省' },
            { id: 6, name: null, enName: '', cnName: '', code: '6', nativeName: '广东省' },
            { id: 7, name: null, enName: '', cnName: '', code: '7', nativeName: '广西壮族自治区' },
            { id: 8, name: null, enName: '', cnName: '', code: '8', nativeName: '贵州省' },
            { id: 9, name: null, enName: '', cnName: '', code: '9', nativeName: '海南省' },
            { id: 10, name: null, enName: '', cnName: '', code: '10', nativeName: '河北省' },
            { id: 11, name: null, enName: '', cnName: '', code: '11', nativeName: '河南省' },
            { id: 12, name: null, enName: '', cnName: '', code: '12', nativeName: '黑龙江省' },
            { id: 13, name: null, enName: '', cnName: '', code: '13', nativeName: '湖北省' },
            { id: 14, name: null, enName: '', cnName: '', code: '14', nativeName: '湖南省' },
            { id: 15, name: null, enName: '', cnName: '', code: '15', nativeName: '吉林省' },
            { id: 16, name: null, enName: '', cnName: '', code: '16', nativeName: '江苏省' },
            { id: 17, name: null, enName: '', cnName: '', code: '17', nativeName: '江西省' },
            { id: 18, name: null, enName: '', cnName: '', code: '18', nativeName: '辽宁省' },
            { id: 19, name: null, enName: '', cnName: '', code: '19', nativeName: '内蒙古自治区' },
            { id: 20, name: null, enName: '', cnName: '', code: '20', nativeName: '宁夏回族自治区' },
            { id: 21, name: null, enName: '', cnName: '', code: '21', nativeName: '青海省' },
            { id: 22, name: null, enName: '', cnName: '', code: '22', nativeName: '山东省' },
            { id: 23, name: null, enName: '', cnName: '', code: '23', nativeName: '山西省' },
            { id: 24, name: null, enName: '', cnName: '', code: '24', nativeName: '陕西省' },
            { id: 25, name: null, enName: '', cnName: '', code: '25', nativeName: '上海市' },
            { id: 26, name: null, enName: '', cnName: '', code: '26', nativeName: '四川省' },
            { id: 27, name: null, enName: '', cnName: '', code: '27', nativeName: '天津市' },
            { id: 28, name: null, enName: '', cnName: '', code: '28', nativeName: '西藏自治区' },
            { id: 29, name: null, enName: '', cnName: '', code: '29', nativeName: '新疆维吾尔自治区' },
            { id: 30, name: null, enName: '', cnName: '', code: '30', nativeName: '云南省' },
            { id: 31, name: null, enName: '', cnName: '', code: '31', nativeName: '浙江省' },
            { id: 32, name: null, enName: '', cnName: '', code: '32', nativeName: '重庆市' },
            { id: 33, name: null, enName: '', cnName: '', code: '33', nativeName: '香港特别行政区' },
            { id: 34, name: null, enName: '', cnName: '', code: '34', nativeName: '澳门特别行政区' },
            { id: 35, name: null, enName: '', cnName: '', code: '35', nativeName: '台湾省' },
            { id: 3438, name: null, enName: '', cnName: '桃花坞', code: '12314131', nativeName: '桃花坞' },
            { id: 3439, name: null, enName: '', cnName: '', code: 'test1111', nativeName: 'test1111' },
            { id: 3441, name: null, enName: '', cnName: '', code: 'qrqwerqewr', nativeName: 'qreqwer' }
          ],
          total: 37,
          size: 5000,
          current: 1,
          searchCount: true,
          pages: 1
        }
      }
      if (code === RESPONSE_SUCCESS) {
        const { records } = data
        records.map(item => (item.isSelectActive = false))
        this.provinceList = records
        // if (this.FormValue.length) {
        //   const provinceId = this.FormValue[0]
        //   const obj = this.provinceList.find(item => item.id === provinceId)
        //   if (obj) obj.isSelectActive = true
        //   this.clearable = true
        //   this.getCityList(provinceId)
        // }
      } else {
        this.$message.success(msg)
      }
    },
    // 获取市区数据
    async getCityList(parentId) {
      // const { data, code, msg } = await this.reqSysArea({ parentId })
      const { data, code, msg } = {
        code: 1,
        msg: '请求成功',
        data: {
          records: [
            { id: 52, name: null, enName: '', cnName: '', code: '52', nativeName: '北京' },
            { id: 3437, name: null, enName: '', cnName: '', code: 'L001', nativeName: '区域名称' }
          ],
          total: 2,
          size: 5000,
          current: 1,
          searchCount: true,
          pages: 1
        }
      }
      if (code === RESPONSE_SUCCESS) {
        const { records } = data
        records.map(item => (item.isSelectActive = false))
        this.cityList = records
        // if (this.FormValue.length > 1) {
        //   const cityId = this.FormValue[0]
        //   const obj = this.cityList.find(item => item.id === cityId)
        //   if (obj) obj.isSelectActive = true
        //   this.getAreaList(cityId)
        // }
      } else {
        this.$message.success(msg)
      }
    },
    // 获取区县数据
    async getAreaList(parentId) {
      // const { data, code, msg } = await this.reqSysArea({ parentId })
      const { data, code, msg } = {
        code: 1,
        msg: '请求成功',
        data: {
          records: [
            { id: 500, name: null, enName: '', cnName: '', code: '500', nativeName: '东城区' },
            { id: 501, name: null, enName: '', cnName: '', code: '501', nativeName: '西城区' },
            { id: 502, name: null, enName: '', cnName: '', code: '502', nativeName: '海淀区' },
            { id: 503, name: null, enName: '', cnName: '', code: '503', nativeName: '朝阳区' },
            { id: 504, name: null, enName: '', cnName: '', code: '504', nativeName: '崇文区' },
            { id: 505, name: null, enName: '', cnName: '', code: '505', nativeName: '宣武区' },
            { id: 506, name: null, enName: '', cnName: '', code: '506', nativeName: '丰台区' },
            { id: 507, name: null, enName: '', cnName: '', code: '507', nativeName: '石景山区' },
            { id: 508, name: null, enName: '', cnName: '', code: '508', nativeName: '房山区' },
            { id: 509, name: null, enName: '', cnName: '', code: '509', nativeName: '门头沟区' },
            { id: 510, name: null, enName: '', cnName: '', code: '510', nativeName: '通州区' },
            { id: 511, name: null, enName: '', cnName: '', code: '511', nativeName: '顺义区' },
            { id: 512, name: null, enName: '', cnName: '', code: '512', nativeName: '昌平区' },
            { id: 513, name: null, enName: '', cnName: '', code: '513', nativeName: '怀柔区' },
            { id: 514, name: null, enName: '', cnName: '', code: '514', nativeName: '平谷区' },
            { id: 515, name: null, enName: '', cnName: '', code: '515', nativeName: '大兴区' }
          ],
          total: 16,
          size: 5000,
          current: 1,
          searchCount: true,
          pages: 1
        }
      }
      if (code === RESPONSE_SUCCESS) {
        const { records } = data
        records.map(item => (item.isSelectActive = false))
        this.areaList = records
        // if (this.FormValue.length > 2) {
        //   const areaId = this.FormValue[2]
        //   const obj = this.areaList.find(item => item.id === areaId)
        //   if (obj) obj.isSelectActive = true
        //   this.updataValue(defaultData)
        // }
      } else {
        this.$message.success(msg)
      }
    },
    // 选中
    selectListClick(id) {
      if (this.typeClass === 0) {
        this.getCityList(id)
        this.provinceList.map(item => (item.isSelectActive = false))
        const obj = this.provinceList.find(item => item.id === id)
        if (obj) {
          obj.isSelectActive = true
          this.addressInfo.provinceId = obj.id
          this.addressInfo.provinceName = obj.nativeName
          this.initData[1].disable = false
          const { areaName, cityName, provinceName } = this.addressInfo
          this.valueInput = this.showLevel === 1 ? `${provinceName}` : `${provinceName} / `
          if (this.type === 'search') {
            this.$emit('update:value', obj.id)
          }
        }
        if (this.showLevel === 1) this.hideModal()
        if (this.showLevel > 1) this.clickTab(1)
      } else if (this.typeClass === 1) {
        this.getAreaList(id)
        this.cityList.map(item => (item.isSelectActive = false))
        const obj = this.cityList.find(item => item.id === id)
        if (obj) {
          obj.isSelectActive = true
          this.addressInfo.cityId = obj.id
          this.addressInfo.cityName = obj.nativeName
          this.initData[2].disable = false
          const { areaName, cityName, provinceName } = this.addressInfo
          this.valueInput = this.showLevel === 2 ? `${provinceName} / ${cityName}` : `${provinceName} / ${cityName} / `
          if (this.type === 'search') {
            this.$emit('update:value', obj.id)
          }
        }
        if (this.showLevel === 2) this.hideModal()
        if (this.showLevel > 2) this.clickTab(2)
      } else {
        this.areaList.map(item => (item.isSelectActive = false))
        const obj = this.areaList.find(item => item.id === id)
        if (obj) {
          obj.isSelectActive = true
          this.addressInfo.areaId = obj.id
          this.addressInfo.areaName = obj.nativeName
          const { areaName, cityName, provinceName } = this.addressInfo
          this.valueInput = `${provinceName} / ${cityName} / ${areaName}`
          this.isShow = false
          this.clearable = true
          this.clickTab(0)
          if (this.type === 'search') {
            this.$emit('update:value', obj.id)
          }
        }
      }
    },
    // 传递选中的值到父组件
    // updataValue(addressInfo) {
    //   const { provinceIdProp, provinceNameProp, cityIdProp, cityNameProp, areaIdProp, areaNameProp } = this.initAddressData.formProps
    //   const data = {}
    //   data[provinceIdProp] = addressInfo.provinceId
    //   data[provinceNameProp] = addressInfo.provinceName
    //   data[cityIdProp] = addressInfo.cityId
    //   data[cityNameProp] = addressInfo.cityName
    //   data[areaIdProp] = addressInfo.areaId
    //   data[areaNameProp] = addressInfo.areaName
    //   this.$emit('update:value', data)
    // },
    // 清空选中
    clearInput() {
      setTimeout(() => {
        // console.log('this.$refs.pronice', this.$refs.pList)
        const { clientWidth } = this.$refs.pList[0]
        this.lineWidth = clientWidth
        this.defaultDataLen = false
        this.valueInput = ''
        this.initData.map(item => (item.disable = true))
        this.initData[0].disable = false
        this.$emit('update:value', '')
      }, 10)
    }
  }
}
</script>
<style lang="scss" scoped>
$selectH: 360px;
.custom-province {
  position: relative;
  .el-select__caret {
    transform: rotateZ(180deg);
    transition: transform 0.3s;
    cursor: pointer;
  }
  .el-icon-circle-close {
    line-height: 32px;
  }
  span,
  .el-input__suffix {
    cursor: pointer;
  }
  .el-scrollbar__wrap {
    overflow: auto;
    // max-height: $selectH;
    height: $selectH;
    min-width: 200px;
  }
  div {
    box-sizing: border-box;
  }
  .disable {
    opacity: 0.5;
    cursor: not-allowed !important;
  }
  .cp-modal {
    position: absolute;
    background: #ffffff;
    width: 100%;
    // height: $selectH;
    height: 300px;
    overflow-y: auto;
    z-index: 9999;
    top: 37px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #dddddd;
    .cpm-ul {
      display: flex;
      height: 28px;
      align-items: center;
      border-bottom: 1px solid #dddddd;
      padding: 0 10px;
      position: relative;
      .isActive {
        font-weight: bolder;
      }
      .cpml-line {
        width: 50px;
        height: 2px;
        transform: rotateZ(180deg);
        transition: transform 0.3s;
        position: absolute;
        bottom: -1px;
        left: 0;
      }
      .cpml-li {
        cursor: pointer;
        margin-left: 7px;
        color: #999999;
        font-size: 14px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .cpm-content {
      padding-top: 5px;
      .cpmc-li {
        width: 100%;
        padding-left: 20px;
        color: #999999;
        font-size: 12px;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
      }
    }
  }
}
</style>
